export default "__VITE_ASSET__39edcb71__"